import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PlaylistsService {

  private apiUrl = 'https://www.aspiresecurities.com/webdataapi/api/playlists/getplaylists';
  constructor(private http: HttpClient) { }
  getPlaylists(): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}`);
  }

}
